<template>
  <!-- 该组件基于el-input封装（要参与表单验证） -->
  <div class="eb-textarea">
    <!-- 顶部遮罩 -->
    <!-- <div class="maskTop"></div> -->
    <!-- 文本域 -->
    <el-input 
      id="link" 
      v-model="textAreaVal" 
      class="groupTextarea"
      type="textarea" 
      clearable 
      :rows="rows" 
      v-bind="$attrs" 
      v-on="$listeners" 
      @input="handleInputChange" 
      :disabled="disabled"
      :placeholder="placeholderTxt"
    ></el-input>
    <!-- 字数统计 -->
    <div class="groupCount">
      <span class="remain">{{valueLength}}</span>
      <span>/</span>
      <span class="maximum">{{maxLength}}</span>
    </div>
    <!-- 复制 -->
    <div class="groupRight">
      <i 
        @click="fuzhi($event)"
        data-clipboard-action="copy"
        data-clipboard-target="#link"
        class="iconfont icon-fuzhi-3 copy"
      ></i>
    </div>
    <!-- 工具栏底部遮罩 -->
    <div class="groupToolFloor"></div>
    <div class="groupTool"></div>
  </div>
</template>
<script>
import clipboard from "../../javascript/clipboard.js";

const isEmpty = (str) => {
  if (str === '' || str === undefined || str === null) {
    return true;
  }
  return false;
}

export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    rows: {
      type: Number,
      default: 3,
    },
    maxLength: {
      type: Number,
      default: 512,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      textAreaVal: '',
      placeholderTxt: '',
    }
  },
  computed: {
  	// 当前文本框中内容字数
    valueLength() {
      if (isEmpty(this.textAreaVal)) {
        return 0;
      }
      return this.textAreaVal.length;
    }
  },
  watch: {
  	// 监听value
    value: {
      handler(val, oldVal) {
        this.textAreaVal = val;
      },
      immediate: true,
    },
  	// 监听placeholder
    // 注：Vue单向数据流（不要修改props）
    placeholder: {
      handler(val, oldVal) {
        this.placeholderTxt = val;
      },
      immediate: true,
    }
  },
  methods: {
  	// textAreaVal超过最大值则直接截断
    handleInputChange() {
      this.textAreaVal = this.textAreaVal.substring(0, this.maxLength)
      this.$emit('change', this.textAreaVal)
    },
    // 复制
    fuzhi(event) {
      // 如果是禁用状态就直接return
      if(this.disabled)return;
      // ................
      // console.log("fuzhi-textAreaVal", this.textAreaVal);
      // console.log("fuzhi-event", event);
      clipboard(this.textAreaVal, event);
    },
  }
}
</script>
<style lang="less" scoped>
</style>
